import { useEffect, useRef, useState } from "react";
import { Play, Pause, X } from "lucide-react";

const fmt = (s) => { s = Math.floor(s || 0); return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`; };

export const TVPlayer = ({ item, onClose }) => {
  const ref = useRef(null);
  const [paused, setPaused] = useState(false);
  const [t, setT] = useState({ cur: 0, dur: 0 });
  const [osd, setOsd] = useState(true);
  const hideTimer = useRef(null);

  const poke = () => { setOsd(true); clearTimeout(hideTimer.current); hideTimer.current = setTimeout(() => setOsd(false), 3500); };

  useEffect(() => {
    poke();
    const onKey = (e) => {
      const v = ref.current; if (!v) return;
      const k = e.key;
      if (k === "Enter" || k === " " || k === "MediaPlayPause") { v.paused ? v.play() : v.pause(); }
      else if (k === "ArrowRight" || k === "MediaFastForward") v.currentTime = Math.min(v.duration || 0, v.currentTime + 10);
      else if (k === "ArrowLeft" || k === "MediaRewind") v.currentTime = Math.max(0, v.currentTime - 10);
      else if (k === "Escape" || k === "Backspace" || k === "GoBack") onClose();
      else if (k !== "ArrowUp" && k !== "ArrowDown") return;
      e.preventDefault(); e.stopPropagation(); poke();
    };
    window.addEventListener("keydown", onKey, true);
    return () => { window.removeEventListener("keydown", onKey, true); clearTimeout(hideTimer.current); };
  }, [onClose]);

  const pct = t.dur ? (t.cur / t.dur) * 100 : 0;
  return (
    <div className="fixed inset-0 z-50 bg-black" data-testid="tv-player" onMouseMove={poke}>
      <video ref={ref} src={item.url} autoPlay playsInline className="w-full h-full object-contain" data-testid="tv-player-video"
        onPlay={() => setPaused(false)} onPause={() => setPaused(true)} onEnded={onClose}
        onTimeUpdate={e => setT({ cur: e.target.currentTime, dur: e.target.duration })}
        onClick={() => { const v = ref.current; v.paused ? v.play() : v.pause(); }}/>
      <div className={`absolute inset-0 pointer-events-none transition-opacity duration-300 ${osd || paused ? "opacity-100" : "opacity-0"}`}>
        <div className="absolute top-0 inset-x-0 p-[3vw] bg-gradient-to-b from-black/80 to-transparent flex items-start justify-between">
          <div>
            <div className="h-font text-3xl lg:text-4xl font-extrabold">{item.title}</div>
            <div className="text-white/60 text-lg mt-1">@{item.creator}</div>
          </div>
          <button onClick={onClose} data-testid="tv-player-close" className="pointer-events-auto w-12 h-12 rounded-full bg-white/10 flex items-center justify-center"><X size={22}/></button>
        </div>
        <div className="absolute bottom-0 inset-x-0 p-[3vw] bg-gradient-to-t from-black/80 to-transparent">
          <div className="flex items-center gap-4">
            {paused ? <Play size={28} className="text-[#00E7FF]"/> : <Pause size={28} className="text-[#00E7FF]"/>}
            <span className="text-lg tabular-nums">{fmt(t.cur)}</span>
            <div className="flex-1 h-2 rounded-full bg-white/20 overflow-hidden"><div className="h-full bg-[#00E7FF]" style={{ width: `${pct}%` }}/></div>
            <span className="text-lg tabular-nums text-white/60">{fmt(t.dur)}</span>
          </div>
          <div className="text-white/40 text-sm mt-3">OK play/pause · ◀ ▶ seek 10s · Back to return</div>
        </div>
      </div>
    </div>
  );
};
